<template>
    <div class="main">
        <v-container fluid class="pa-0">
            <v-card class="d-flex ml-2 pt-2 pb-0 flex-row" outlined>
                <v-form class="slim">
                    <v-container class="d-flex ml-2 pt-2 flex-row flex-wrap">
                        <v-autocomplete class="pr-2 mx-320" v-model="filter.idNTipoSupervisor" :items="tiposSupervisor" item-text="fldTNombre" item-value="idNTipoSupervisor" 
                                        label="Tipo Supervisor" v-on:keyup.enter="loadData" clearable outlined dense></v-autocomplete>
                        <v-autocomplete class="pr-2 mx-320" v-model="filter.idNVersionSupervisor" :items="versionesSupervisor" item-text="fldTNombre" item-value="idNVersionSupervisor" 
                                        label="Version Supervisor" v-on:keyup.enter="loadData" clearable outlined dense></v-autocomplete>
                        <v-autocomplete class="pr-2 mx-320" v-model="filter.idNTipoElemento" :items="tiposElementos" item-text="fldTNombre" item-value="idNTipoElemento" 
                                        label="Tipo Elmento" v-on:keyup.enter="loadData" clearable outlined dense></v-autocomplete>
                        <v-autocomplete class="pr-2 mx-320" v-model="filter.fkNTipoVariable" :items="variablesClasses" item-text="fldTNombre" item-value="idNTipoVariable" 
                                        label="Tipo Variable" v-on:keyup.enter="loadData" clearable outlined dense></v-autocomplete>

                        <v-row>
                            <v-checkbox class="ml-4 mt-1" v-model="filter.fldBVer" label="Ver" outlined dense :indeterminate="filter.fldBVer == null" @change="chkfldVerFueTrue"></v-checkbox>
                            <v-checkbox class="ml-4 mt-1" v-model="filter.fldBEditar" label="Editar" outlined dense :indeterminate="filter.fldBEditar == null" @change="chkfldEditarFueTrue"></v-checkbox>
                        </v-row>

                        <v-card-actions class="btns-float">
                            <v-btn color="grey" @click="clearFilter" small>Limpiar</v-btn>
                            <v-btn color="accent" dark small @click="loadData">Filtrar</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-form>
            </v-card>
        </v-container>
        <v-container fluid class="pa-0">
            <v-card class="d-flex ml-2 pt-2 pb-0 flex-row" outlined>
                <v-form class="slim">
                    <v-container class="d-flex ml-2 pt-2 flex-row flex-wrap">
                        <v-autocomplete class="pr-2 mx-320" v-model="filter.fkNTipoUsuario" :items="userTypes" item-text="fldTNombre" item-value="idNTipoUsuario" label="Tipo de Usuario" @change="loadData" 
                                        clearable outlined dense></v-autocomplete>
                        <span style="color: red; font-size:14px; margin-top: 5px;">(* Seleccione el tipo de usuario)</span>
                    </v-container>
                </v-form>
            </v-card>
        </v-container>

        <!-- Edit Form -->
        <template>
            <v-row>
                <v-dialog persistent v-model="editForm" max-width="500">
                    <v-card class="mx-auto">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>Editar Permiso</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-form ref="formularioEdicion" class="slim">
                            <v-container class="d-flex pt-6 flex-row flex-wrap ">
                                <v-text-field class="pr-3 mx-320" v-model="permiso.fkNTipoVariable" label="Id Tipo Variable" :disabled="true" outlined dense></v-text-field>
                                <v-text-field class="pr-3 mx-320" v-model="permiso.fldTNombre" label="Nombre" :disabled="true" outlined dense></v-text-field>
                                <br />
                                <v-row class="ml-5 mt-3 mb-5">
                                    <v-checkbox class="pr-3 mt-n2" label="Ver" v-model="permiso.fldBVer" :disabled="puedeCambiar == false" outlined dense></v-checkbox>
                                    <v-checkbox class="pr-3 mt-n2" label="Editar" v-model="permiso.fldBEditar" :disabled="puedeCambiar == false" outlined dense></v-checkbox>
                                </v-row>
                                <!--<small>* Indica que es un campo obligatorio</small>-->

                                <v-card-actions class="justify-space-between w-100 pb-6">
                                    <div class="justify-right">
                                        <v-btn class="ma-2" small color="blue lighten-5" @click="chkBotonCancelar">
                                            Cancelar
                                        </v-btn>
                                        <v-btn v-if="puedeCambiar == false" class="ma-2" dark small color="success" @click="puedeCambiar = true">
                                            <v-icon left>mdi-pencil</v-icon> Editar
                                        </v-btn>
                                        <v-btn v-else class="ma-2" dark small color="success" @click="saveData">
                                            <v-icon left>mdi-pencil</v-icon> Guardar
                                        </v-btn>
                                    </div>
                                </v-card-actions>
                            </v-container>
                        </v-form>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>

        <v-container fluid class="pt-0">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-card>
                        <template>
                            <v-data-table dense :headers="headers" item-key="idNPermiso" :items="permisosList"
                                          :footer-props="{'items-per-page-options': [5, 10, 20, 50]}" class="elevation-1 gt slim">

                                <template v-slot:item.action="{ item }">
                                    <v-icon color="green" @click="editItem(item)" class="ml-3">
                                        mdi-pencil
                                    </v-icon>
                                </template>

                                <template v-slot:item.fldBVer="{item}">
                                    <v-icon v-if="item.fldBVer">mdi-check</v-icon>
                                    <v-icon v-else>mdi-window-close</v-icon>
                                </template>

                                <template v-slot:item.fldBEditar="{item}">
                                    <v-icon v-if="item.fldBEditar">mdi-check</v-icon>
                                    <v-icon v-else>mdi-window-close</v-icon>
                                </template>

                            </v-data-table>
                        </template>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { Component, Prop, Vue } from "vue-property-decorator";
    import PermisoService from '../services/PermisoService';
    import PermisoModel from '../models/PermisoModel';
    import UserService from '../services/UserService';
    import VariableClassService from '@/services/VariableClassService';
    import SupervisorTypeService from '@/services/SupervisorTypeService';
    import VersionService from '@/services/VersionService';
    import ElementTypeService from '@/services/ElementTypeService';

    @Component({
        mounted: async function () {
            await this.loadData();
        },
        methods: {
            loadData: async function () {
                try {

                    if (this.$data.filter.fkNTipoUsuario < 1) {
                        this.$data.filter.fkNTipoUsuario = null;
                    }

                    var tipos = await new UserService().listTypes();
                    this.$data.userTypes = tipos;

                    var resultVC = await new VariableClassService().list({});
                    if (resultVC.success) {
                        this.$data.variablesClasses = resultVC.data;
                    }
                    else {
                        this.showError('Ocurrio un error: ' + resultVC.Message);
                    }  

                    var resultTS = await new SupervisorTypeService().list({});
                    if (resultTS.success) {
                        this.$data.tiposSupervisor = resultTS.data;
                    }
                    else {
                        this.showError('Ocurrio un error: ' + resultTS.Message);
                    }

                    var resultV = await new VersionService().list({});
                    if (resultV.success) {
                        this.$data.versionesSupervisor = resultV.data;
                    }
                    else {
                        this.showError('Ocurrio un error: ' + resultV.Message);
                    }
                    
                    var resultET = await new ElementTypeService().list({});
                    if (resultET.success) {
                        this.$data.tiposElementos = resultET.data;
                    }
                    else {
                        this.showError('Ocurrio un error: ' + resultET.Message);
                    }

                    var resultP = await new PermisoService().list(this.$data.filter);
                    if (resultP.success) {
                        this.$data.permisosList = resultP.data;
                    }
                    else {
                        this.showError('Ocurrio un error: ' + resultP.Message);
                    }

                } catch (e) {
                    console.log(e);
                }
            },
            chkfldVerFueTrue() {
                if (this.$data.filter.fldBVer == true) {
                    if (this.$data.fldVerFueTrue == true) {
                        this.$data.filter.fldBVer = null;
                        this.$data.fldVerFueTrue = false;
                    } else {
                        this.$data.fldVerFueTrue = true;
                    }
                }
            },
            chkfldEditarFueTrue() {
                if (this.$data.filter.fldBEditar == true) {
                    if (this.$data.fldEditarFueTrue == true) {
                        this.$data.filter.fldEditar = null;
                        this.$data.fldEditarFueTrue = false;
                    } else {
                        this.$data.fldEditarFueTrue = true;
                    }
                }
            },
            clearFilter: function () {
                this.filter = new PermisoModel();
                //Reseteamos los contadores usados para manejar el indeterminado
                this.$data.fldVerFueTrue = false;
                this.$data.fldEditarFueTrue = false;
                this.$data.filter.fldBVer = null;
                this.$data.filter.fldBEditar = null;
                this.loadData();
            },
            //getTipoVariableDescription(id) {
            //    let desc = this.$data.variablesClasses.find(function (e) {
            //        return e.fkNTipoVariable == id;
            //    });
            //    if (desc)
            //        return desc.fldTNombre;
            //    return id;
            //},

            chkBotonCancelar() {
                // Estoy editando y presiono cancelar
                if (this.$data.puedeCambiar == true && this.$data.editForm == true) {
                    this.$data.permiso = JSON.parse(JSON.stringify(this.$data.permisoAux));
                    this.$data.puedeCambiar = false;
                } else {
                    this.closeDialog();
                }
            },
            closeDialog() {
                this.editForm = false;
                this.puedeCambiar = false;
                this.alert = false;
                this.$data.permiso = new PermisoModel();
                this.$data.permisoAux = new PermisoModel();
            },
            editItem(item) {
                this.$data.permiso = JSON.parse(JSON.stringify(item));
                this.$data.permisoAux = JSON.parse(JSON.stringify(item));
                this.$data.editForm = true;
            },
            saveData: async function () {
                try {

                    if (this.$refs.formularioEdicion != null) {
                        if (!this.$refs.formularioEdicion.validate()) {
                            return;
                        }
                    }

                    var uService = new PermisoService(this.filter);
                    var data = await uService.update(this.$data.permiso);

                    if (data.success) {
                        this.closeDialog();
                        this.loadData();
                        this.showSuccess('El registro fue guardado correctamente');
                    } else {
                        this.showError('Ocurrio un error al guardar el registro: ' + data.error);
                    }
                } catch (e) {
                    console.log(e);
                }
            },
        }

    })
    export default class Permisos extends Vue {

        editForm = false;
        puedeCambiar = false;

        // Listas
        permisosList = [];
        userTypes = [];
        variablesClasses = [];
        tiposSupervisor = [];
        versionesSupervisor = [];
        tiposElementos = [];

        // Para Indeterminados
        fldVerFueTrue = false;
        fldEditarFueTrue = false;

        // Modelos
        permiso = new PermisoModel();
        permisoAux = new PermisoModel();
        filter = new PermisoModel();

        headers = [
            {
                text: '',
                value: 'action',
                sortable: false,
                width: 15
            },
            { text: 'Id Tipo Variable', value: 'fkNTipoVariable' },
            { text: 'Tipo Supervisor', value: 'tipoSupervisor' },
            { text: 'Version', value: 'version' },
            { text: 'Tipo Elemento', value: 'tipoElemento' },
            { text: 'Tipo Variable', value: 'tipoVariable' },
            { text: 'Tipo Usuario', value: 'tipoUsuario' },
            { text: 'Ver', value: 'fldBVer' },
            { text: 'Editar', value: 'fldBEditar' }
        ];
}
</script>
